import { hasNewsAccess } from "@slfinrtl/ppn-roles"
import { useMemo } from "react"
import { getFeatureToggle } from "src/common/getConfig"
import { getJwtPayload } from "src/common/jwt/jwtUtils"

/** access to the news list and to existing entries, also for reviewers */
export const useHasNewsAccess = (): boolean =>
	useMemo(() => {
		const jwtClaims = getJwtPayload()
		return getFeatureToggle("news-enabled") && !!jwtClaims && hasNewsAccess(jwtClaims["ppn:groups"])
	}, [])
